import PropTypes from 'prop-types';
import { Box, Link, useTheme, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  link: {
    margin: '5px',
  },
});

const SharingButtons = ({
  instagram,
  facebook,
  twitter,
  linkedin,
  youtube,
}) => {
  const theme = useTheme();
  const classes = useStyles();
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      color="primary"
    >
      {instagram && (
        <Link
          className={classes.link}
          href={instagram}
          aria-label={instagram}
          target="_blank"
          rel="noreferrer"
        >
          <svg
            id="instagram-logo"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            fill={theme.palette.primary.main}
            transform="scale(0.75)"
          >
            <path
              d="M16 8.536c1.476 0 2.845.369 4.107 1.107a8.238 8.238 0 0 1 3 3 7.993 7.993 0 0 1 1.107 4.107 7.993 7.993 0 0 1-1.107 4.107 8.238 8.238 0 0 1-3 3A7.993 7.993 0 0 1 16 24.964a7.993 7.993 0 0 1-4.107-1.107 8.238 8.238 0 0 1-3-3 7.993 7.993 0 0 1-1.107-4.107c0-1.476.369-2.845 1.107-4.107a8.238 8.238 0 0 1 3-3A7.993 7.993 0 0 1 16 8.536zm0 13.571c1.476 0 2.738-.524 3.786-1.571 1.047-1.048 1.571-2.31 1.571-3.786s-.524-2.738-1.571-3.786c-1.048-1.047-2.31-1.571-3.786-1.571s-2.738.524-3.786 1.571c-1.047 1.048-1.571 2.31-1.571 3.786s.524 2.738 1.571 3.786c1.048 1.047 2.31 1.571 3.786 1.571zM26.5 8.18c-.048.523-.25.976-.607 1.357a1.74 1.74 0 0 1-1.322.571c-.523 0-.976-.19-1.357-.571a1.854 1.854 0 0 1-.571-1.357c0-.524.19-.977.571-1.358a1.854 1.854 0 0 1 1.357-.571c.524 0 .977.19 1.358.571.38.381.571.834.571 1.358zm5.429 1.928c.047 1.334.071 3.548.071 6.643 0 3.095-.036 5.321-.107 6.679-.072 1.357-.274 2.535-.607 3.535a8.325 8.325 0 0 1-1.965 3.107 8.325 8.325 0 0 1-3.107 1.965c-1 .333-2.178.535-3.535.607-1.358.071-3.584.107-6.679.107s-5.321-.036-6.679-.107c-1.357-.072-2.535-.298-3.535-.679a7.614 7.614 0 0 1-3.107-1.893 8.325 8.325 0 0 1-1.965-3.107c-.333-1-.535-2.178-.607-3.535C.036 22.07 0 19.845 0 16.75s.036-5.321.107-6.679C.18 8.714.381 7.536.714 6.536A8.325 8.325 0 0 1 2.68 3.429a8.325 8.325 0 0 1 3.107-1.965c1-.333 2.178-.535 3.535-.607C10.68.786 12.905.75 16 .75s5.321.036 6.679.107c1.357.072 2.535.274 3.535.607a8.325 8.325 0 0 1 3.107 1.965 8.325 8.325 0 0 1 1.965 3.107c.333 1 .547 2.19.643 3.571zM28.5 26.18c.286-.81.476-2.096.571-3.858.048-1.047.072-2.523.072-4.428v-2.286c0-1.952-.024-3.428-.072-4.428-.095-1.81-.285-3.096-.571-3.858-.571-1.476-1.595-2.5-3.071-3.071-.762-.286-2.048-.476-3.858-.571-1.047-.048-2.523-.072-4.428-.072h-2.286c-1.905 0-3.38.024-4.428.072-1.762.095-3.048.285-3.858.571-1.476.571-2.5 1.595-3.071 3.071-.286.762-.476 2.048-.571 3.858-.048 1.047-.072 2.523-.072 4.428v2.286c0 1.905.024 3.38.072 4.428.095 1.762.285 3.048.571 3.858.619 1.476 1.643 2.5 3.071 3.071.81.286 2.096.476 3.858.571 1.047.048 2.523.072 4.428.072h2.286c1.952 0 3.428-.024 4.428-.072 1.81-.095 3.096-.285 3.858-.571 1.476-.619 2.5-1.643 3.071-3.071z"
              fillRule="nonzero"
            />
          </svg>
        </Link>
      )}
      {facebook && (
        <Link
          className={classes.link}
          href={facebook}
          aria-label={facebook}
          target="_blank"
          rel="noreferrer"
        >
          <svg
            id="facebook-logo"
            xmlns="http://www.w3.org/2000/svg"
            width="32px"
            height="32px"
            x="8"
            fill={theme.palette.primary.main}
            transform="scale(0.75)"
          >
            <path
              transform="translate(8, 0)"
              d="M4.813 32V17.687H0V12h4.813V7.5c0-2.375.666-4.219 2-5.531C8.146.656 9.916 0 12.125 0c1.792 0 3.25.083 4.375.25v5.063h-3c-1.125 0-1.896.25-2.313.75-.333.416-.5 1.083-.5 2V12H16l-.75 5.688h-4.563V32H4.814z"
              fillRule="nonzero"
            />
          </svg>
        </Link>
      )}
      {twitter && (
        <Link
          className={classes.link}
          href={twitter}
          aria-label={twitter}
          target="_blank"
          rel="noreferrer"
        >
          <svg
            id="twitter-logo"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            fill={theme.palette.primary.main}
            transform="scale(0.75)"
          >
            <path
              transform="translate(0, 2)"
              d="M28.688 6.875c.041.167.062.438.062.813 0 3-.73 5.895-2.188 8.687-1.5 2.958-3.604 5.313-6.312 7.063-2.958 1.958-6.354 2.937-10.188 2.937-3.666 0-7.02-.98-10.062-2.937.458.041.98.062 1.563.062 3.041 0 5.77-.937 8.187-2.812-1.458 0-2.74-.428-3.844-1.282-1.104-.854-1.864-1.927-2.281-3.218.417.041.813.062 1.188.062a8.33 8.33 0 0 0 1.75-.187c-1.5-.334-2.75-1.105-3.75-2.313-1-1.208-1.5-2.583-1.5-4.125V9.5a6.178 6.178 0 0 0 2.937.875A7.28 7.28 0 0 1 2.125 8a6.304 6.304 0 0 1-.813-3.156c0-1.146.313-2.24.938-3.281a18.096 18.096 0 0 0 5.969 4.875 18.166 18.166 0 0 0 7.531 2c-.083-.5-.125-1-.125-1.5 0-1.167.292-2.26.875-3.282a6.423 6.423 0 0 1 2.375-2.406c1-.583 2.083-.875 3.25-.875.958 0 1.844.188 2.656.563a7.423 7.423 0 0 1 2.157 1.5c1.5-.292 2.895-.813 4.187-1.563-.5 1.542-1.458 2.75-2.875 3.625 1.25-.167 2.5-.52 3.75-1.062a14.426 14.426 0 0 1-3.313 3.437z"
            />
          </svg>
        </Link>
      )}
      {linkedin && (
        <Link
          className={classes.link}
          href={linkedin}
          aria-label={linkedin}
          target="_blank"
          rel="noreferrer"
        >
          <svg
            id="linkedin-logo"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            fill={theme.palette.primary.main}
            transform="scale(0.70)"
          >
            <path
              d="M7.143 32.75H.5V11.393h6.643V32.75zM3.857 8.464c-1.047 0-1.952-.38-2.714-1.143C.38 6.56 0 5.655 0 4.607 0 3.56.381 2.655 1.143 1.893S2.81.75 3.857.75c1.048 0 1.953.381 2.714 1.143.762.762 1.143 1.667 1.143 2.714 0 1.048-.38 1.953-1.143 2.714-.761.762-1.666 1.143-2.714 1.143zM32 32.75h-6.643V22.321c0-1.714-.143-2.952-.428-3.714-.524-1.286-1.548-1.928-3.072-1.928s-2.595.571-3.214 1.714c-.476.857-.714 2.119-.714 3.786V32.75h-6.572V11.393h6.357v2.928h.072c.476-.952 1.238-1.738 2.285-2.357 1.143-.762 2.477-1.143 4-1.143 3.096 0 5.262.977 6.5 2.929.953 1.571 1.429 4 1.429 7.286V32.75z"
              fillRule="nonzero"
            />
          </svg>
        </Link>
      )}
      {youtube && (
        <Link
          className={classes.link}
          href={youtube}
          aria-label={youtube}
          target="_blank"
          rel="noreferrer"
        >
          <svg
            id="youtube-logo"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            fill={theme.palette.primary.main}
            transform="scale(1.2)"
          >
            <path
              transform="translate(4,4)"
              d="M10 15l5.19-3L10 9v6m11.56-7.83c.13.47.22 1.1.28 1.9.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83-.25.9-.83 1.48-1.73 1.73-.47.13-1.33.22-2.65.28-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44-.9-.25-1.48-.83-1.73-1.73-.13-.47-.22-1.1-.28-1.9-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83.25-.9.83-1.48 1.73-1.73.47-.13 1.33-.22 2.65-.28 1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44.9.25 1.48.83 1.73 1.73z"
            />
          </svg>
        </Link>
      )}
    </Box>
  );
};

SharingButtons.defaultProps = {
  facebook: null,
  twitter: null,
  linkedin: null,
  instagram: null,
  youtube: null,
};

SharingButtons.propTypes = {
  facebook: PropTypes.string,
  twitter: PropTypes.string,
  linkedin: PropTypes.string,
  instagram: PropTypes.string,
  youtube: PropTypes.string,
};

export default SharingButtons;
